// ======================================================================
// File Name       : RoleRegisterEditConfirm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import RoleDetail from './RoleDetail';
import { MODAL_SIZE } from '../../constants/index';
import MessageView from '../MessageView';
import { MESSAGE_TYPE } from '../../constants/index';

const RoleRegisterEditConfirm = ({
  showModal,
  bsSize,
  authority,
  onRegisterEditOk,
  onRegisterEditCancel,
}) => {
  const style = {
    background: 'none',
    width: 'auto',
    height: 'auto',
    marginLeft: 0,
    left: 0,
  };

  return (
    <Modal
      className="modal-container"
      show={showModal}
      onHide={onRegisterEditCancel}
      size={MODAL_SIZE.lg}
    >
      <Modal.Header onHide={onRegisterEditCancel} closeButton>
        <Modal.Title className="text-center">
          以下の内容で登録します
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <RoleDetail authority={authority} />
      </Modal.Body>
      <Modal.Footer className="text-center">
        <Button variant="default" className="margin-10 btn-96" onClick={onRegisterEditCancel}>
          キャンセル
        </Button>
        <Button variant="primary" className="margin-10 btn-96" onClick={onRegisterEditOk}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleRegisterEditConfirm;
